// Module
var code = "<div id=\"cmp_empty\" class=\"ml-modal\"> <div class=\"ml-modal-card-md\"> <i id=\"cmp_dialog_empty\" class=\"ml_close\"></i> <div id=\"cmp_dialog_empty_body\" class=\"ml-modal-content-wrap\"> </div> </div> </div> ";
// Exports
export default code;